<template>
  <!-- ========== Left Sidebar Start ========== -->
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="(item, index) in menuItems">
        <li class="menu-title" v-if="item.is_title" :key="index">
          {{ displayName(item) }}
        </li>

        <div v-if="item.is_title && item.items" :key="index + '_'">
          <template v-for="(item2, index2) in item.items">
            <li :key="index2" :ref="`li1_1_${index2}`">
              <a
                v-if="hasItems(item2)"
                href="javascript:void(0);"
                class="is-parent"
                @click="onToggleSubMenu(index2, 1)"
                :class="{
                  'has-arrow': !item2.badge,
                  'has-dropdown': item2.badge,
                }"
              >
                <i :class="`bx ${item2.icon}`" v-if="item2.icon"></i>
                <span>{{ $t(displayName(item2)) }}</span>
                <span
                  :class="`badge badge-pill badge-${item2.badge.variant} float-right`"
                  v-if="item2.badge"
                  >{{ $t(item2.badge.text) }}</span
                >
              </a>
              <router-link
                :to="{ name: item2.route_name }"
                v-if="!hasItems(item2)"
                class="side-nav-link-ref"
              >
                <i :class="`bx ${item2.icon}`" v-if="item2.icon"></i>
                <span>{{ $t(displayName(item2)) }}</span>
                <span
                  :class="`badge badge-pill badge-${item2.badge.variant} float-right`"
                  v-if="item2.badge"
                  >{{ $t(item2.badge.text) }}</span
                >
              </router-link>

              <ul
                v-if="hasItems(item2)"
                class="sub-menu mm-collapse"
                aria-expanded="false"
                :ref="`submenu_1_1_${index2}`"
              >
                <li
                  v-for="(subitem2, subindex2) of item2.items"
                  :key="subindex2"
                  :ref="`li2_${subindex2}`"
                >
                  <router-link
                    :to="{ name: subitem2.route_name }"
                    v-if="!hasItems(subitem2)"
                    class="side-nav-link-ref"
                    >{{ $t(displayName(subitem2)) }}</router-link
                  >
                  <a
                    v-if="hasItems(subitem2)"
                    class="side-nav-link-a-ref has-arrow"
                    href="javascript:void(0);"
                    @click="onToggleSubMenu(subindex2, 2)"
                    >{{ $t(displayName(subitem2)) }}</a
                  >
                  <ul
                    v-if="hasItems(subitem2)"
                    class="sub-menu mm-collapse"
                    aria-expanded="false"
                    :ref="`submenu_1_2_${subindex2}`"
                  >
                    <li
                      v-for="(subSubitem2, subSubIndex2) of subitem2.items"
                      :key="subSubIndex2"
                    >
                      <router-link
                        :to="{ name: subSubitem2.route_name }"
                        class="side-nav-link-ref"
                        >{{ $t(displayName(subitem2)) }}</router-link
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </template>
        </div>

        <li v-else :key="index" :ref="`li1_${index}`">
          <a
            v-if="hasItems(item)"
            href="javascript:void(0);"
            class="is-parent"
            @click="onToggleSubMenu(index, 1)"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(displayName(item)) }}</span>
            <span
              :class="`badge badge-pill badge-${item.badge.variant} float-right`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </a>
          <router-link
            :to="{ name: item.route_name }"
            v-if="!hasItems(item)"
            class="side-nav-link-ref"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(displayName(item)) }}</span>
            <span
              :class="`badge badge-pill badge-${item.badge.variant} float-right`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </router-link>

          <ul
            v-if="hasItems(item)"
            class="sub-menu mm-collapse"
            aria-expanded="false"
            :ref="`submenu1_${index}`"
          >
            <li
              v-for="(subitem, subindex) of item.items"
              :key="subindex"
              :ref="`li2_${subindex}`"
            >
              <router-link
                :to="{ name: subitem.route_name }"
                v-if="!hasItems(subitem)"
                class="side-nav-link-ref"
                >{{ $t(displayName(subitem)) }}</router-link
              >
              <a
                v-if="hasItems(subitem)"
                class="side-nav-link-a-ref has-arrow"
                href="javascript:void(0);"
                @click="onToggleSubMenu(subindex, 2)"
                >{{ $t(displayName(subitem)) }}</a
              >
              <ul
                v-if="hasItems(subitem)"
                class="sub-menu mm-collapse"
                aria-expanded="false"
                :ref="`submenu2_${subindex}`"
              >
                <li
                  v-for="(subSubitem, subSubIndex) of subitem.items"
                  :key="subSubIndex"
                >
                  <router-link
                    :to="{ name: subSubitem.route_name }"
                    class="side-nav-link-ref"
                    >{{ $t(displayName(subSubitem)) }}</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
  <!--- Sidemenu -->
  <!-- <div id="sidebar-menu">
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="(item, index) in menuItems">
        <li class="menu-title" v-if="item.sTitle" :key="`title_${index}`">
          {{ $t(item.is_title) }}
        </li>
        <li
          v-if="!item.is_title && !item.isLayout"
          :key="`li1_${index}`"
          :ref="`li1_${index}`"
        >
           <router-link :to="item.link" v-if="!hasItems(item)" class="side-nav-link-ref">
           <i
              :class="`bx ${item.icon}`"
              v-if="item.icon"
            ></i>
            <span>{{ $t(item.view_name) }}</span>
          </router-link>

          <a
            v-if="hasItems(item)"
            href="javascript:void(0);"
            class="is-parent"
            @click="onToggleSubMenu(index, 1)"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.view_name) }}</span>
          </a>
          <ul
            v-if="hasItems( item)"
            :ref="`submenu1_${index}`"
            class="sub-menu mm-collapse"
            aria-expanded="false"
          >
            <li
              v-for="(subitem, subIndex) of item.items"
              :key="`li2_${subIndex}`"
              :ref="`li2_${subIndex}`"
            >
              <a
                v-if="hasItems(subitem)"
                href="javascript:void(0);"
                class="is-parent"
                @click="onToggleSubMenu(subIndex, 2)"
                :class="{
                  'has-arrow': !subitem.badge,
                  'has-dropdown': subitem.badge,
                }"
              >
                <i :class="`bx ${subitem.icon}`" v-if="subitem.icon"></i>
                <span>{{ $t(subitem.view_name) }} {{ subitem.level }}</span>
              </a>
              <ul
                v-if="hasItems(subitem)"
                class="sub-menu mm-collapse"
                aria-expanded="false"
                :ref="`submenu2_${subIndex}`"
              >
                <li v-for="(subSubitem, subSubIndex) of subitem.items" :key="subSubIndex">
                  <a href="javascript:void(0);" class="is-parent">
                    <i
                      :class="`bx ${subSubitem.icon}`"
                      v-if="subSubitem.icon"
                    ></i>
                    <span>{{ $t(subSubitem.view_name) }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div> -->
  <!-- Sidebar -->
</template>


<script>
import axios from "axios";
import authorizeProvider from "@/helpers/service/authorize-provider";
const HttpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 60000,
});

export default {
  data() {
    return {
      menuItems: [],
    };
  },

  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    // new MetisMenu("#side-menu");
  },
  updated() {
    this.matchingMenu();
  },
  async created() {
    this.onGetMenuItems();
  },
  methods: {
    displayName(item) {
      if(this.$validate.isObjectValid(item.display_name)) {
        if (this.$validate.isTrimValid(item.display_name.en)) {
          return item.display_name.en
        } else if (this.$validate.isTrimValid(item.display_name.th)) {
          return item.display_name.th
        }
      }
      return item.view_name
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      // console.log(item);
      return item.items !== undefined ? item.items.length > 0 : false;
    },

    matchingMenu() {
      var links = document.getElementsByClassName("side-nav-link-ref");
      var matchingMenuItem = null;
      const paths = [];

      for (var i = 0; i < links.length; i++) {
        paths.push(links[i]["pathname"]);
      }
      var itemIndex = paths.indexOf(window.location.pathname);
      if (itemIndex === -1) {
        const strIndex = window.location.pathname.lastIndexOf("/");
        const item = window.location.pathname.substr(0, strIndex).toString();
        matchingMenuItem = links[paths.indexOf(item)];
      } else {
        matchingMenuItem = links[itemIndex];
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        var parent = matchingMenuItem.parentElement;

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add("mm-active");
          const parent2 = parent.parentElement.closest("ul");
          if (parent2 && parent2.id !== "side-menu") {
            parent2.classList.add("mm-show");

            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add("mm-active");
              var childAnchor = parent3.querySelector(".has-arrow");
              var childDropdown = parent3.querySelector(".has-dropdown");
              if (childAnchor) childAnchor.classList.add("mm-active");
              if (childDropdown) childDropdown.classList.add("mm-active");

              const parent4 = parent3.parentElement;
              if (parent4 && parent4.id !== "side-menu") {
                parent4.classList.add("mm-show");
                const parent5 = parent4.parentElement;
                if (parent5 && parent5.id !== "side-menu") {
                  parent5.classList.add("mm-active");
                  const childanchor = parent5.querySelector(".is-parent");
                  if (childanchor && parent5.id !== "side-menu") {
                    childanchor.classList.add("mm-active");
                  }
                }
              }
            }
          }
        }
      }
    },
    async onGetMenuItems() {
      var accessToken = this.$cookies.get(".at");
      if (accessToken === null)
        window.location = "/login";
      
      const responsed = await authorizeProvider.getMenuItems(accessToken);

      if (responsed.status == 200) {
        this.menuItems = responsed.data.menuItems;
      } else if (responsed.status == 404) console.log("ไม่มีสิทธิ์");
    },
    onToggleSubMenu(index, submenu) {
      if (
        this.$refs[`submenu${submenu}_${index}`][0].classList.contains(
          "mm-show"
        )
      ) {
        this.$refs[`submenu${submenu}_${index}`][0].classList.remove("mm-show");
        this.$refs[`li${submenu}_${index}`][0].classList.remove("mm-active");
      } else {
        this.$refs[`submenu${submenu}_${index}`][0].classList.add("mm-show");
        this.$refs[`li${submenu}_${index}`][0].classList.add("mm-active");
      }
    },
  },
};
</script>
  

  